import type { InvestmentItem } from './mergeInvestmentsByLabel';

export const recalculateWeights = <T extends InvestmentItem>(items: T[]): T[] => {
  return recalculateWeightsInternal(items, undefined);
};
const recalculateWeightsInternal = <T extends InvestmentItem>(items: T[], total: number | undefined): T[] => {
  const result: T[] = [];
  const totalAllocation = total ?? items.map((y) => y.allocation).reduce((a, b) => a + b, 0);
  items.forEach((item) => {
    result.push({
      ...item,
      weight: totalAllocation ? item.allocation / totalAllocation : 0,
      children: item.children ? recalculateWeightsInternal(item.children, totalAllocation) : undefined,
    } as T);
  });
  return result;
};
